/**
 * Blockable
 *
 * @mixin
 */
import isEqual from 'lodash/isEqual';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      currentAddress: null,
    };
  },
  computed: {
    ...mapState('room', {
    }),
    blocked() {
      return this.$store.getters['room/blockableAddressOwnedByMe'](this.currentAddress) === false;
    },
  },
  methods: {
    async onRoomUpdated(room) {
      await this.$store.dispatch('room/UPDATE_ROOM', room);
    },
    async joinRoom(address) {
      await this.$store.dispatch('room/JOIN_ROOM', address);
    },
    async leaveRoom() {
      await this.$store.dispatch('room/LEAVE_CURRENT_ROOM');
    },
  },
  created() {
    this.overlord.service('rooms').on('created', this.onRoomUpdated);
    this.overlord.service('rooms').on('updated', this.onRoomUpdated);
    this.overlord.service('rooms').on('removed', this.onRoomUpdated);
  },
  async beforeDestroy() {
    this.overlord.service('rooms').removeListener('created', this.onRoomUpdated);
    this.overlord.service('rooms').removeListener('updated', this.onRoomUpdated);
    this.overlord.service('rooms').removeListener('removed', this.onRoomUpdated);
    // Si no existe currentAddress no podemos abandonar nada
    if (this.currentAddress) {
      await this.leaveRoom();
    }
  },
  async beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      // access to component instance via `vm`
      const address = {
        name: to.name,
        params: vm.address,
      };
      // Use the page custom address
      await vm.joinRoom(address);
      vm.currentAddress = address;
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await next();

    const newAddress = {
      name: to.name,
      params: this.address,
    };

    if (this.currentAddress
      && isEqual(this.currentAddress, newAddress)) {
      return;
    }

    await this.leaveRoom();
    await this.joinRoom(newAddress);
    this.currentAddress = newAddress;
  },
};
